import { FC } from 'react'
import { HomeBanner } from '@/network/graphql.g'
import BannersLayout, {
  BannersType
} from '@/components/organisms/bannersLayout'

type CategoryProductBannerProps = {
  banners: HomeBanner[]
} & Rest

const CategoryProductBanner: FC<CategoryProductBannerProps> = ({
  banners,
  ...rest
}) => {
  return (
    <>
      {banners && banners?.length > 0 && (
        <BannersLayout
          banners={banners}
          bannerDst={BannersType.CategoryProduct}
          mb={0}
          mt={{ desktop: 0, tablet: 0, mobile: 12 }}
          {...rest}
        />
      )}
    </>
  )
}

export default CategoryProductBanner
